import React from 'react'

import { Typography, Select } from '@telavita-core/react-design-kit'

import { TypeForm } from '../../types/forms'

import * as S from './styles'
import { MedicalRecordFormType } from 'models/MedicalRecord/MedicalRecordForm.type'

interface MedicalRecordFormTypeSelectProps {
  selectedTypeForm: TypeForm
  onSelectedTypeFormChange: (formId) => void
  disabled?: boolean
  options: TypeForm[]
}

export function MedicalRecordFormTypeSelect({
  onSelectedTypeFormChange,
  selectedTypeForm,
  disabled,
  options,
}: MedicalRecordFormTypeSelectProps): JSX.Element {
  return (
    <S.MedicalRecordFormTypeSelectContainer>
      <S.TitleContainer>
        <Typography weight='bolder' variant='content2'>
          Tipo de formulário
        </Typography>
      </S.TitleContainer>
      <Select
        dataCy='form-type'
        label=''
        onSelect={(form) => onSelectedTypeFormChange(form.id as string)}
        options={options}
        selected={selectedTypeForm}
        disabled={disabled}
      />
      {selectedTypeForm.id === MedicalRecordFormType.TECHNICAL_EVALUATION && (
        <S.SelectLegendContainer>
          <Typography variant='content3' italic>
            Não é possível modificar o tipo, pois este é o momento de fazer uma
            avaliação técnica.
          </Typography>
        </S.SelectLegendContainer>
      )}
    </S.MedicalRecordFormTypeSelectContainer>
  )
}
